// src/components/InvoiceForm.js
import React, { useState } from "react";

function InvoiceForm({ open, onClose, onSubmit, defaultService }) {
  const [service, setService] = useState(defaultService || "");
  const [price, setPrice] = useState("");
  const [invoiceDate, setInvoiceDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const [paymentStatus, setPaymentStatus] = useState("Pending");

  if (!open) return null;

  return (
    <div className="invoice-modal-backdrop">
      <div className="invoice-modal">
        <h2>Generate Invoice</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit({ service, price, invoiceDate, paymentStatus });
          }}
        >
          <div>
            <label>Service</label>
            <input
              value={service}
              onChange={(e) => setService(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Price</label>
            <input
              value={price}
              type="number"
              min="0"
              onChange={(e) => setPrice(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Date</label>
            <input
              value={invoiceDate}
              type="date"
              onChange={(e) => setInvoiceDate(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Status</label>
            <select
              value={paymentStatus}
              onChange={(e) => setPaymentStatus(e.target.value)}
            >
              <option value="Pending">Pending</option>
              <option value="Paid">Paid</option>
            </select>
          </div>
          <div style={{ marginTop: 12 }}>
            <button type="submit">Create Invoice</button>
            <button type="button" onClick={onClose} style={{ marginLeft: 8 }}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default InvoiceForm;
